import AppLogo from '@/components/layout/app-logo';
import { login } from '@/routes/admin';
import { Link } from '@inertiajs/react';

export function HomeFooter() {
    return (
        <footer className="border-t border-slate-200/70 bg-white/80 text-sm text-slate-500 backdrop-blur-sm dark:border-slate-700/60 dark:bg-gray-950/80 dark:text-slate-400">
            <div className="mx-auto w-full max-w-6xl px-6 py-10">
                <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
                    <div className="space-y-3">
                        <Link
                            href="/"
                            aria-label="Return to Staydeed home"
                            className="inline-flex items-center"
                        >
                            <span className="flex items-center gap-2">
                                <AppLogo />
                            </span>
                        </Link>
                        <p className="max-w-sm text-base text-slate-600">
                            Boutique motel experiences tailored for city
                            explorers, remote creatives, and couples looking for
                            an elegant pause.
                        </p>
                        <div className="flex flex-wrap gap-4 text-xs tracking-wide text-slate-400 uppercase dark:text-slate-500">
                            <span>Check-in 3 PM</span>
                            <span>Check-out 11 AM</span>
                            <span>Concierge 24/7</span>
                        </div>
                    </div>
                    <div className="space-y-3">
                        <h3 className="text-sm font-semibold tracking-wide text-slate-700 uppercase">
                            Plan your stay
                        </h3>
                        <ul className="space-y-2">
                            <li>
                                <Link
                                    href="#highlights"
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    Explore highlights
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href="#moments"
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    Stay moments
                                </Link>
                            </li>
                            <li>
                                <Link
                                    href="#stories"
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    Guest stories
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="space-y-3">
                        <h3 className="text-sm font-semibold tracking-wide text-slate-700 uppercase">
                            Guest services
                        </h3>
                        <ul className="space-y-2">
                            <li>
                                <Link
                                    href={login()}
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    Manage reservation
                                </Link>
                            </li>
                            {/* <li>
                                <Link
                                    href={register()}
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    Reserve your stay
                                </Link>
                            </li> */}
                            <li>
                                <Link
                                    href="/"
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    Loyalty benefits
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="space-y-3">
                        <h3 className="text-sm font-semibold tracking-wide text-slate-700 uppercase">
                            Connect with us
                        </h3>
                        <ul className="space-y-2">
                            <li>
                                <a
                                    href="tel:+13125551212"
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    +1 (312) 555-1212
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:hello@staydeed.test"
                                    className="transition hover:text-slate-900 dark:hover:text-white"
                                >
                                    hello@staydeed.test
                                </a>
                            </li>
                            <li className="text-slate-600">
                                112 orchard row
                                <br />
                                Chicago, IL 60601
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mt-8 grid gap-3 border-t border-slate-200/60 pt-6 text-xs text-slate-400 sm:grid-cols-2 sm:items-center dark:border-slate-700/50 dark:text-slate-500">
                    <span>
                        © {new Date().getFullYear()} Staydeed. All rights
                        reserved.
                    </span>
                    <div className="flex flex-wrap items-center gap-4 sm:justify-end">
                        <Link
                            href="/"
                            className="transition hover:text-slate-900 dark:hover:text-white"
                        >
                            Privacy
                        </Link>
                        <Link
                            href="/"
                            className="transition hover:text-slate-900 dark:hover:text-white"
                        >
                            Accessibility
                        </Link>
                        <Link
                            href="/"
                            className="transition hover:text-slate-900 dark:hover:text-white"
                        >
                            Sustainability
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
